import { EngagementDeliveryInfoResponseDto } from '@epicuro-next/data/engagement/engagement-models';

export const mapProductDeliveryInfoToEarliestDeliveryDate = (
  deliveryInfo: EngagementDeliveryInfoResponseDto[],
) => {
  const sortedDeliveryInfo = [...deliveryInfo].sort(
    (a, b) =>
      new Date(a.deliveryDate).getTime() - new Date(b.deliveryDate).getTime(),
  );
  return sortedDeliveryInfo?.[0]?.deliveryDate ?? null;
};
